import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { FaSearch } from 'react-icons/fa'
import Query from './Query'

const Search = styled.div`
  padding: 3rem 0;
  width: 100%;

  > div {
    display: inline-block;
  }

  form {
    display: flex;

    > div {
      display: flex;
      flex-direction: column;
      justify-content: center;

      &:last-of-type {
        padding: 0 1rem;
        background-color: ${({ theme }) => theme.colors.primaryHighlight};
        border: 0.1rem solid ${({ theme }) => theme.colors.darkText};
      }
    }
  }

  input {
    display: block;
    max-width: 40rem;
    width: 100%;
    padding: 0.8rem 1.6rem;
    margin: 0 auto;
    background-color: ${({ theme }) => theme.colors.primaryHighlight};
    color: ${({ theme }) => theme.colors.text};
    border: 0.1rem solid ${({ theme }) => theme.colors.darkText};
    border-right: none;
    font-style: ${({ value }) => (value.length > 0 ? 'normal' : 'italic')};
    position: relative;
    z-index: 1;
    pointer-events: auto;
    min-width: 28rem;

    @media screen and (max-width: 500px) {
      min-width: 0;
    }

    &:focus {
      outline: none;
      border-top-color: ${({ theme }) => theme.colors.interactive};
    }
  }

  button {
    background-color: transparent;
    border: none;
    color: ${({ theme }) => theme.colors.text};
    text-transform: uppercase;
    cursor: pointer;
  }

  p {
    text-align: center;
    margin-top: 1.2rem;
  }
`

const SearchForm = ({ onSubmit, totalResults, search }) => {
  const [value, setValue] = useState('')

  function onFormSubmit(e) {
    e.preventDefault()
    onSubmit(value)
  }

  useEffect(() => {
    setValue(search)
  }, [search])

  return (
    <Query
      render={({ content }) => (
        <Search value={value}>
          <div>
            <form onSubmit={onFormSubmit}>
              <div>
                <input
                  name="search"
                  role="search"
                  aria-label={content.search}
                  id="search"
                  type="text"
                  value={value}
                  placeholder={content.search}
                  onChange={(e) => setValue(e.target.value)}
                  autoComplete="off"
                />
              </div>
              <div>
                <button
                  onClick={onFormSubmit}
                  aria-label={content.search_submit}
                >
                  <FaSearch />
                </button>
              </div>
            </form>
          </div>
          <p>
            <em>
              {totalResults} {content.results}
            </em>
          </p>
        </Search>
      )}
    />
  )
}

SearchForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  totalResults: PropTypes.number.isRequired
}

export default SearchForm
